export const TOUR_MIN_OPEN_PANELS = 1;
